import { IconArrowToTop } from "@suse-o11y/icons";
import { Tooltip, TooltipBoundary, TooltipTrigger } from "@suse-o11y/tooltip";
import { useResizeObserver } from "@suse-o11y/use-resize-observer";
import React from "react";

import { Button } from "./react/buttons/Button";
import { useClosestScrollingContainer } from "./_scrolling-container";

export interface ScrollToTopProps {
	/**
	 * @default "Back to top"
	 */
	tooltip?: string;

	/**
	 * @default true
	 */

	isVisible?: boolean;
	className?: string;
}

export const ScrollToTop: React.FC<ScrollToTopProps> = ({ tooltip = "Back to top", isVisible = true, className }) => {
	const { element, scrollTo } = useClosestScrollingContainer();
	const rect = useResizeObserver(element);

	const isScrollable = element != null && rect != null && element.scrollHeight > rect.height;

	if (!(isVisible && isScrollable)) {
		return null;
	}

	return (
		<TooltipBoundary>
			<TooltipTrigger asChild>
				<Button
					className={className}
					onClick={() => {
						scrollTo({ top: 0 });
					}}
					shape="circle"
					size="large"
					type="dark"
				>
					<IconArrowToTop className="mx-auto text-white text-xs" />
				</Button>
			</TooltipTrigger>

			<Tooltip className="tooltip/tooltip">{tooltip}</Tooltip>
		</TooltipBoundary>
	);
};
